// frontend/src/pages/admin/lcl/LclPage.jsx
import { useState } from 'react';
import { FiSettings, FiFileText, FiCreditCard, FiClock, FiBookOpen } from 'react-icons/fi';
import MandatesTab from './tabs/MandatesTab';
import PrelevementsTab from './tabs/PrelevementsTab';
import HistoryTab from './tabs/HistoryTab';
import HelpTab from './tabs/HelpTab';
import LclSettingsModal from './components/LclSettingsModal';

const TABS = [
  { key: 'mandates',     label: 'Mandats',       icon: FiFileText },
  { key: 'prelevements', label: 'Prélèvements',  icon: FiCreditCard },
  { key: 'history',      label: 'Historique',    icon: FiClock },
  { key: 'help',         label: "Mode d'emploi", icon: FiBookOpen },
];

export default function LclPage() {
  const [tab, setTab] = useState('mandates');
  const [settingsOpen, setSettingsOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 p-3">
      <div className="max-w-7xl mx-auto space-y-3">

        {/* Header */}
        <div className="bg-white rounded shadow border border-gray-200 px-3 py-2
                        flex items-center justify-between">
          <div>
            <div className="text-sm font-bold text-gray-900">Export LCL SEPA</div>
            <div className="text-[10px] text-gray-500">
              Génération des fichiers CSV Mandats et CSV Prélèvements pour le portail LCL
            </div>
          </div>
          <button
            onClick={() => setSettingsOpen(true)}
            className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded text-[11px]
                       font-medium text-gray-600 border border-gray-200 hover:bg-gray-50"
            title="Configuration créancier"
          >
            <FiSettings className="h-3.5 w-3.5" />
            Configuration
          </button>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded border border-gray-200 p-1 inline-flex">
          {TABS.map(({ key, label, icon: Icon }) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-[11px] font-semibold transition-colors ${
                tab === key
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <Icon className="h-3.5 w-3.5" />
              {label}
            </button>
          ))}
        </div>

        {/* Content */}
        {tab === 'mandates'     && <MandatesTab />}
        {tab === 'prelevements' && <PrelevementsTab />}
        {tab === 'history'      && <HistoryTab />}
        {tab === 'help'         && <HelpTab />}
      </div>

      <LclSettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </div>
  );
}
